import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const TermsIcon = _ref => {
  let {
      size = "41",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("g", {
    id: "03-Im\xC3\xA1genes-e-Iconos/Iconos/UI-M/Ayuda-Contacto/ConsultarP&R"
  }, __jsx("g", {
    id: "icon-consultarP&R"
  }, __jsx("path", {
    id: "Shape",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.0929 16.1484H29.9054V18.7109H17.0929V16.1484ZM17.0929 25.1172H29.9054V22.5547H17.0929V25.1172ZM17.0929 31.5234H29.9054V28.9609H17.0929V31.5234ZM11.9679 18.7109H14.5304V16.1484H11.9679V18.7109ZM11.9679 25.1172H14.5304V22.5547H11.9679V25.1172ZM11.9679 31.5234H14.5304V28.9609H11.9679V31.5234ZM35.0304 11.7794V35.3672C35.0304 37.49 33.3095 39.2109 31.1867 39.2109H11.3145C8.84491 39.2109 6.84285 37.209 6.84285 34.7394V7.83313C6.8361 6.64276 7.30419 5.49881 8.14351 4.65467C8.98284 3.81054 10.1241 3.33594 11.3145 3.33594H26.587L26.9714 3.7075L34.6589 11.395L35.0304 11.7794ZM32.4679 35.3672V13.5859H27.3429C25.9277 13.5859 24.7804 12.4387 24.7804 11.0234V5.89844H11.3145C10.8082 5.89844 10.3226 6.09957 9.96457 6.45759C9.60655 6.81561 9.40525 7.30118 9.40525 7.8075V34.7137C9.39856 35.2245 9.59666 35.7167 9.95543 36.0803C10.3142 36.4438 10.8037 36.6484 11.3145 36.6484H31.1867C31.8943 36.6484 32.4679 36.0748 32.4679 35.3672ZM27.3429 7.705V11.0234H30.6614L27.3429 7.705Z",
    fill: color
  }))));
};
export default TermsIcon;